<template>
  <div class="tables">
    <div class="list-box">
      <runs-list></runs-list>
    </div>
    <div class="list-box">
      <exclusive-list></exclusive-list>
    </div>
  </div>
</template>

<script>
import RunsList from './RunsList'
import ExclusiveList from './ExclusiveList'

export default {
  name: 'runs-table',
  components: { RunsList, ExclusiveList },
  data () {
    return {
    }
  },
  computed: {
    runs () { return this.$store.state.runs },
  }
}
</script>

<style lang="scss" scoped>
.tables{
  height: 100%;
}
.list-box{
  height: 50%;
  overflow-y: hidden;
  overflow-x: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/Runs/Tables.vue